export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_LOADING = "SIGN_IN_LOADING";
export const SIGN_IN_ERROR = "SIGN_IN_ERROR";
export const SIGN_IN_REMOVE_ERROR = "SIGN_IN_REMOVE_ERROR";

export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_LOADING = "SIGN_UP_LOADING";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";
export const SIGN_UP_REMOVE_ERROR = "SIGN_UP_REMOVE_ERROR";

export const G_SIGN_UP_LOADING = "G_SIGN_UP_LOADING";
export const G_SIGN_UP_SUCCESS = "G_SIGN_UP_SUCCESS";
export const G_SIGN_UP_ERROR = "G_SIGN_UP_ERROR";
export const G_SIGN_UP_REMOVE_ERROR = "G_SIGN_UP_REMOVE_ERROR";

export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_ERROR = "SIGN_OUT_ERROR";

export const UPDATE_EDITOR_HEADER_SETTINGS = "UPDATE_EDITOR_HEADER_SETTINGS";

export const UPDATE_CODE_VALUE = "UPDATE_CODE_VALUE";

export const SEND_MESSAGE = "SEND_MESSAGE";

export const FETCH_USERS = "FETCH_USERS";

export const UPDATE_CODE_CHAT_WITH = "UPDATE_CODE_CHAT_WITH";

export const PUSH_EDITOR_CODE_VALUE = "PUSH_EDITOR_CODE_VALUE";

export const PULL_EDITOR_CODE_VALUE = "PULL_EDITOR_CODE_VALUE";

export const MESSAGING_SUCCESS = "MESSAGING_SUCCESS";
export const FETCH_MESSAGES = "FETCH_MESSAGES";